import React from "react";
import { Button } from "@/components/ui/button";
import { Gift, MessageCircle } from "lucide-react";
import { waLink } from "@/constants/site";

export default function FreeTrial() {
  return (
    <section data-testid="free-trial-section" className="py-20 md:py-28 bg-white">
      <div className="iona-container">
        <div className="relative overflow-hidden rounded-[2rem] bg-[#5E2A84] px-8 py-14 md:px-16 md:py-20">
          {/* Decorative */}
          <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-[#7A3FA8] blur-3xl opacity-40 translate-x-1/3 -translate-y-1/3 pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-[300px] h-[300px] rounded-full bg-[#B892D1] blur-3xl opacity-20 -translate-x-1/2 translate-y-1/2 pointer-events-none" />

          <div className="relative grid md:grid-cols-12 gap-10 items-center">
            <div className="md:col-span-8">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur text-white text-xs uppercase tracking-[0.25em] mb-6 border border-white/20">
                <Gift className="w-3.5 h-3.5" />
                Hediye Fırsatı
              </div>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] tracking-tight mb-5">
                Ücretsiz Deneme <br className="hidden md:block" />
                <span className="italic text-[#E8E2F0]">Seansı Fırsatı</span>
              </h2>
              <p className="text-base md:text-lg text-white/80 max-w-xl leading-relaxed">
                Size en uygun uygulamayı belirlemek ve işlem sürecini detaylı
                öğrenmek için ücretsiz deneme seansı randevusu oluşturabilirsiniz.
              </p>
            </div>
            <div className="md:col-span-4 flex md:justify-end">
              <a
                href={waLink("Merhaba, ücretsiz deneme seansı randevusu oluşturmak istiyorum.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="free-trial-cta"
              >
                <Button className="h-14 px-8 rounded-full bg-white text-[#5E2A84] hover:bg-[#F4F1F9] text-base font-medium iona-soft-shadow">
                  <MessageCircle className="w-5 h-5 mr-2" />
                  Ücretsiz Deneme Randevusu Al
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
